import { render, staticRenderFns } from "./P028.vue?vue&type=template&id=67c96b04"
import script from "./P028.vue?vue&type=script&lang=js"
export * from "./P028.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports